import * as Yup from "yup";

const objectIdRegex = /^[0-9a-fA-F]{24}$/;

export const vendorValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Name must be at least 2 characters")
    .required("Vendor name is required"),

  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
    .required("Mobile number is required"),

  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),

  corporateName: Yup.string()
    .min(2, "Corporate name must be at least 2 characters")
    .required("Corporate name is required"),

  corporateCode: Yup.string()
    .nullable()
    .when("vendorType", {
      is: (val) => val === "Vendor",
      then: (schema) => schema.required("Corporate code is required"),
      otherwise: (schema) => schema.nullable(),
    }),

  adminId: Yup.string()
    .matches(objectIdRegex, "Invalid Admin ID")
    .required("Admin head is required"),

  corporateAdminIds: Yup.array()
    .of(Yup.string().matches(objectIdRegex, "Invalid Corporate Admin ID"))
    .min(1, "Please select at least one Corporate Admin"),

  countryId: Yup.string()
    .matches(objectIdRegex, "Invalid Country ID")
    .required("Country is required"),

  stateId: Yup.string()
    .matches(objectIdRegex, "Invalid State ID")
    .required("State is required"),

  cityId: Yup.string()
    .matches(objectIdRegex, "Invalid City ID")
    .required("City is required"),

  contactPerson: Yup.string()
    .min(2, "Contact person must be at least 2 characters")
    .required("Contact person name is required"),

  vendorType: Yup.string()
    .oneOf(["superVendor", "Vendor"], "Invalid vendor type")
    .required("Vendor type is required"),

  password: Yup.string()
    .nullable()
    .notRequired()
    .transform((value) => (value === "" ? null : value))
    .when("vendorType", {
      is: (val) => val === "Vendor",
      then: (schema) => schema.min(6, "Password must be at least 6 characters"),
      otherwise: (schema) => schema,
    }),

  userId: Yup.string().required("User ID is required"),

  isSuperVendor: Yup.boolean(),
});

export const VendorUpdateValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Name must be at least 2 characters")
    .required("Vendor name is required"),

  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
    .required("Mobile number is required"),

  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),

  corporateName: Yup.string()
    .min(2, "Corporate name must be at least 2 characters")
    .required("Corporate name is required"),

  corporateCode: Yup.string()
    .nullable()
    .when("vendorType", {
      is: (val) => val === "Vendor",
      then: (schema) => schema.required("Corporate code is required"),
      otherwise: (schema) => schema.nullable(),
    }),

  adminId: Yup.string()
    .matches(objectIdRegex, "Invalid Admin ID")
    .required("Admin head is required"),

  corporateAdminIds: Yup.array()
    .of(Yup.string().matches(objectIdRegex, "Invalid Corporate Admin ID"))
    .min(1, "Please select at least one Corporate Admin"),

  countryId: Yup.string()
    .matches(objectIdRegex, "Invalid Country ID")
    .required("Country is required"),

  stateId: Yup.string()
    .matches(objectIdRegex, "Invalid State ID")
    .required("State is required"),

  cityId: Yup.string()
    .matches(objectIdRegex, "Invalid City ID")
    .required("City is required"),

  contactPerson: Yup.string()
    .min(2, "Contact person must be at least 2 characters")
    .required("Contact person name is required"),

  vendorType: Yup.string()
    .oneOf(["superVendor", "Vendor"], "Invalid vendor type")
    .required("Vendor type is required"),

  password: Yup.string()
    .nullable()
    .notRequired()
    .transform((value) => (value === "" ? null : value))
    .when("vendorType", {
      is: (val) => val === "Vendor",
      then: (schema) => schema.min(6, "Password must be at least 6 characters"),
      otherwise: (schema) => schema,
    }),

  userId: Yup.string()
    .min(3, "User ID must be at least 3 characters")
    .max(50, "User ID cannot exceed 50 characters")
    .required("User ID is required"),
  isSuperVendor: Yup.boolean(),
});

export const VendorStaffValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Name must be at least 2 characters")
    .max(100, "Name cannot exceed 100 characters")
    .required("Name is required"),

  countryId: Yup.string().required("Country ID is required"),
  stateId: Yup.string().required("State ID is required"),
  cityId: Yup.string().required("City ID is required"),

  corporateName: Yup.string()
    .min(2, "Corporate name must be at least 2 characters")
    .max(100, "Corporate name cannot exceed 100 characters")
    .required("Corporate name is required"),

  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile must be exactly 10 digits")
    .required("Mobile is required"),

  email: Yup.string()
    .email("Invalid email")
    .required("Email is required"),

  contactPerson: Yup.string()
    .min(2, "Contact person must be at least 2 characters")
    .max(100, "Contact person cannot exceed 100 characters")
    .required("Contact person is required"),

  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .max(100, "Password cannot exceed 100 characters")
    .required("Password is required"),

  userId: Yup.string()
    .min(3, "User ID must be at least 3 characters")
    .max(50, "User ID cannot exceed 50 characters")
    .required("User ID is required"),

  adminId: Yup.string().required("Admin Head is required"),
  addedBy: Yup.string().required("Added By (Vendor) is required"),
  corporateAdminIds: Yup.string()
    .min(1, "Select at least one corporate admin"),
});

export const VendorStaffUpdateValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Name must be at least 2 characters")
    .max(100, "Name cannot exceed 100 characters")
    .required("Name is required"),

  countryId: Yup.string().required("Country ID is required"),
  cityId: Yup.string().required("City ID is required"),
  stateId: Yup.string().required("State ID is required"),

  corporateName: Yup.string()
    .min(2, "Corporate name must be at least 2 characters")
    .max(100, "Corporate name cannot exceed 100 characters")
    .required("Corporate name is required"),

  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile must be exactly 10 digits")
    .required("Mobile is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  contactPerson: Yup.string()
    .min(2, "Contact person must be at least 2 characters")
    .max(100, "Contact person cannot exceed 100 characters")
    .required("Contact person is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .max(100, "Password cannot exceed 100 characters")
    .nullable(),
  userId: Yup.string()
    .min(3, "User ID must be at least 3 characters")
    .max(50, "User ID cannot exceed 50 characters")
    .required("User ID is required"),
});
